module.exports = __webpack_public_path__ + "img/Genuss-Cafe-Torten-QV.612c6652.jpg";